/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboStockManagementBadRequestResponse,
  BboStockManagementFailureResponseResponse,
  BboStockManagementForbiddenResponse,
  BboStockManagementNoContentResponse,
  BboStockManagementUnauthorizedResponse,
  GetSystemStockCountParams,
  SystemStockCount,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get stock count and quantity at system level
 * @summary This endpoint will get the product details on a particular AL
 */
export const getSystemStockCount = (
  accountingLocationID: string,
  params?: GetSystemStockCountParams,
  signal?: AbortSignal,
) => {
  return customInstance<SystemStockCount[] | BboStockManagementNoContentResponse>({
    url: `/bm-stock-management-service/v1/stock-count/system/${accountingLocationID}`,
    method: 'get',
    params,
    signal,
  });
};

export const getGetSystemStockCountQueryKey = (
  accountingLocationID: string,
  params?: GetSystemStockCountParams,
) => {
  return [
    `/bm-stock-management-service/v1/stock-count/system/${accountingLocationID}`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSystemStockCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getSystemStockCount>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(
  accountingLocationID: string,
  params?: GetSystemStockCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSystemStockCount>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSystemStockCountQueryKey(accountingLocationID, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSystemStockCount>>> = ({ signal }) =>
    getSystemStockCount(accountingLocationID, params, signal);

  return { queryKey, queryFn, enabled: !!accountingLocationID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSystemStockCount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSystemStockCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSystemStockCount>>
>;
export type GetSystemStockCountQueryError = ErrorType<
  | BboStockManagementBadRequestResponse
  | BboStockManagementUnauthorizedResponse
  | BboStockManagementForbiddenResponse
  | BboStockManagementFailureResponseResponse
>;

/**
 * @summary This endpoint will get the product details on a particular AL
 */
export const useGetSystemStockCount = <
  TData = Awaited<ReturnType<typeof getSystemStockCount>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(
  accountingLocationID: string,
  params?: GetSystemStockCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSystemStockCount>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSystemStockCountQueryOptions(accountingLocationID, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
